// extracted by mini-css-extract-plugin
module.exports = {"root":"MatchStatus_root__t19Sl","statusTime":"MatchStatus_statusTime__DebHg"};